/**
 * The slot registrations of `web/sheet-form` (1.AC-2 deliverable 8): the stat block pill
 * (`header.pills.statblock`, order 70). `apps/web/src/editor-services/slots.ts` collects them as
 * `SLOT_MODULES['web/sheet-form']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { StatBlockPill } from './StatBlockPill.js';

export const owner: WorkPackageId = '1.AC-2';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.pills', order: 70, owner: '1.AC-2', component: StatBlockPill },
];
